var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBahrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0454 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95443 31.0454 0.00012207 19.9998 0.00012207C8.95406 0.00012207 -0.000244141 8.95443 -0.000244141 20.0001C-0.000244141 31.0458 8.95406 40.0001 19.9998 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 0C15.9861 0 12.2492 1.1832 9.11702 3.21859L14.2607 6.66617L7.82593 9.99945L14.2607 13.3327L7.82593 16.666L14.2607 19.9989L7.82593 23.3321L14.2607 26.6653L7.82593 29.9989L14.2607 33.3322L9.1164 36.7809C12.2487 38.8166 15.9859 40 19.9998 40C31.0455 40 39.9998 31.0456 39.9998 20C39.9998 8.95437 31.0455 0 19.9998 0V0Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahrain);
export default __webpack_public_path__ + "static/media/bahrain.e36c07f42badba97b2b4fe153f5755e0.svg";
export { ForwardRef as ReactComponent };